<div class="dialog-container">
    <h1 mat-dialog-title class="title">{{ data.titleLocalizationKey | i18next }}</h1>

    <div mat-dialog-content class="container">
        <p class="message">
            {{ data.contentMessage | i18next }}
        </p>

        <div class="action-wrapper">
            <a (click)="applyActionAndClose(OkCancelDialogActions.CANCEL)" *ngIf="!data.hideCancel">{{
                'aumico_confirmation_modal_cancel_button' | i18next
            }}</a>
            <a class="confirmation-action" (click)="applyActionAndClose(OkCancelDialogActions.OK)">
                {{ data.actionBtnTextKey | i18next }}
            </a>
        </div>
    </div>
</div>
